import React from 'react';
import { jsx } from 'react/jsx-runtime';

var TabPanels = function TabPanels(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx("div", {
    children: React.Children.map(children, function (child, index) {
      if (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          index: index
        });
      }
      return null;
    })
  });
};
var TabPanels$1 = TabPanels;

export { TabPanels$1 as default };
//# sourceMappingURL=TabPanels.js.map
